import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnEditUser(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos atualizar as informações do usuário.'
            break
        case '2xx':
            message = 'Atualizamos as informações do usuário.'
            break
        case 'invalid':
            message = 'Ops! A informação não pode ser enviada.'
            break
        case 'invalidName':
            message = 'Ops! O campo precisa ser preenchido com mais de 3 caracteres.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não atualizamos as informações do usuário. Por favor, tente novamente mais tarde.'
    }

    return message
}
